import { styled } from "@mui/material";

import RichText from "../../../../ui/components/RichText";
import clsx from "clsx";

const ReacQuillWrapper = styled("div", {
  shouldForwardProp: (prop) =>
    prop !== "backgroundImageURL" && prop !== "aspectRatio",
})(({ theme, backgroundImageURL, aspectRatio }) => ({
  height: "max-content",
  backgroundImage: `url(${backgroundImageURL})`,
  backgroundSize: `cover`,
  overflow: "hidden",
  "& > *": {
    height: "100%",
  },
  ".quill": {
    height: "100%",
    width: "100%",
    maxWidth: "100%",
  },
}));

export default function TextPostContent({ postData, className, ...rest }) {
  return (
    <ReacQuillWrapper
      backgroundImageURL={postData?.background}
      className={clsx("post_content post_content_text", className)}
      aspectRatio={postData?.proporcaoImagem}
      {...rest}
    >
      {postData?.titulo && (
        <RichText
          value={postData?.titulo}
          formats={[
            "header",
            "color",
            "bold",
            "italic",
            "underline",
            "align",
            "emoji",
          ]}
        />
      )}
    </ReacQuillWrapper>
  );
}
